<template>
  <div class="Verification">
    <div class="Verification-logo-width">
      <TheLogo></TheLogo>
    </div>
    <div class="Verification-main">
      <div class="Verification-main-title">身份验证</div>
      <div v-if="slider">
        <div class="Verification-main-tips">
          为了更好地为您提供服务，请您先进行简单的身份验证～
        </div>
        <div class="tel" :class="telStatus ? 'error' : ''">
          <input
            v-model="tel"
            @focus="telFocus"
            placeholder="请输入手机号"
            maxlength="11"
            @input="tel = tel.replace(/[^\d]/g, '')"
          />
        </div>
        <div class="verification-code">
          <input
            v-model="code"
            maxlength="6"
            @focus="codeFocus"
            placeholder="请输入短信验证码"
            @input="code = code.replace(/[^\d]/g, '')"
          />
          <span class="line"></span>
          <el-button
            class="code"
            :disabled="countDown !== 60 ? true : false"
            type="text"
            size="small"
            @click="getCode"
          >
            <span class="getCode" :style="{ color: countDown !== 60 ? '#0072F5' : '' }">{{
              countDown === 60 ? "获取验证码" : `重新获取${countDown}S`
            }}</span>
          </el-button>
        </div>
        <div class="warn" v-if="tips" :style="{ color: 'red' }">{{ tips }}</div>
        <div class="warn" v-if="codeTips" :style="{ color: '#0072F5' }">
          {{ codeTips }}
        </div>
      </div>
      <div v-else>
        <slider-verify
          ref="sliderVerify"
          :canvasWidth="300"
          :canvasHeight="150"
          @success="onSuccess"
          @fail="onFail"
          @again="onAgain"
          :failTip="failTip"
          :resTag="resTag"
        />
      </div>
      <el-button :disabled="!tag" type="primary" @click="submit">提交验证</el-button>
    </div>
  </div>
</template>
<script>
import api from "@/api/index";
export default {
  name: "Verification",
  data() {
    return {
      tel: "",
      code: "",
      countDown: 60,
      tips: "",
      isCode: false,
      codeTips: "",
      telStatus: false,
      failTip: "",
      captcha: {},
      isShowSliderVerify: false,
      slider: true,
      tag: false,
      resTag: 1,
      sign: false,
    };
  },
  methods: {
    /* 滑动验证成功 */
    onSuccess(captcha) {
      this.captcha = captcha;
      this.login();
    },
    onFail(msg) {
      // if(msg) this.resTag = 2
      this.$refs.sliderVerify.isPassing = true;
    },
    onAgain() {
      this.$message("error", "滑动操作异常，请重试");
    },
    async login() {
      let res = null;
      res = await api.getImageVerifyCode(this.captcha);
      if (res.code === 0) {
        if (res.data && res.data.successFlag === -1) {
          this.$refs.sliderVerify.verifyFailEvent(res.data.errorMsg);
          return;
        }
        this.$refs.sliderVerify.verifySuccessEvent();
        this.isShowSliderVerify = false;
        this.tag = true;
        this.sign = true;
        this.slider = true;
        this.resTag = 1;
        this.getCode();
      } else {
        this.slider = false;
      }
      this.isShowSliderVerify = false;
      this.resTag = 2;
    },
    close() {
      this.$store.commit("app/CHANGE_STATUS", false);
    },
    codeFocus() {
      this.tips = "";
    },
    telFocus() {
      this.tips = "";
      this.telStatus = false;
    },
    getCode() {
      this.tips = "";
      if (!this.tel) {
        this.tips = "手机号输入不能为空";
        this.telStatus = true;
        return;
      } else if (this.tel && !/^1[3456789]\d{9}$/.test(this.tel)) {
        this.tips = "请输入正确的手机号，否则无法接收验证码";
        this.telStatus = true;
        return;
      } else {
        this.code = "";
        this.isCode = true;
        this.slider = false;
        if (this.tag) {
          api.sendVerifyCode({ phoneNum: this.tel, type: "DSR_TYPE" }).then((res) => {
            if (res.code === 0) {
              this.slider = true;
              this.codeTips = "验证码已发送";
              this.timer = setInterval(() => {
                if (this.countDown === 1) {
                  this.countDown = 60;
                  this.codeTips = "";
                  this.tag = false;
                  // this.resTag = 1
                  clearInterval(this.timer);
                } else {
                  this.countDown -= 1;
                }
              }, 1000);
            } else {
              this.slider = false;
              this.tips = res.msg;
              setTimeout(() => {
                this.tips = "";
              }, 3000);
            }
          });
        }
      }
    },
    // getCode() {
    //   this.tips = ''
    //   if (!this.tel) {
    //     this.tips = '手机号输入不能为空';
    //     this.telStatus = true;
    //   } else if (this.tel && !/^1[3456789]\d{9}$/.test(this.tel)) {
    //     this.tips = '请输入正确的手机号，否则无法接收验证码';
    //     this.telStatus = true;
    //   } else {
    //     this.code = '';
    //     this.isCode = true;
    //     api.sendVerifyCode({ phoneNum: this.tel, type: 'DSR_TYPE' }).then((res) => {
    //       if (res.code === 0) {
    //         this.codeTips = '验证码已发送';
    //         this.timer = setInterval(() => {
    //           if (this.countDown === 1) {
    //             this.countDown = 60;
    //             this.isCode = false;
    //             this.codeTips = '';
    //             clearInterval(this.timer);
    //           } else {
    //             this.countDown -= 1;
    //           }
    //         }, 1000);
    //       } else {
    //         this.tips = res.msg;
    //         setTimeout(() => {
    //           this.tips = '';
    //         }, 3000);
    //       }
    //     });
    //   }
    // },
    submit() {
      if (!this.tel) {
        this.tips = "手机号输入不能为空";
        this.telStatus = true;
      } else if (this.tel && !/^1[3456789]\d{9}$/.test(this.tel)) {
        this.tips = "请输入正确的手机号";
      } else {
        this.loginParam = {
          userPhone: this.tel,
          type: "DSR_TYPE",
          verifyCode: this.code,
        };
        api.submitAuth(this.loginParam).then((res) => {
          if (res.code === -1) {
            this.codeTips = "";
            this.tips = res.msg.split(";").join("");
          }
          if (!res.code) {
            this.codeTips = "";
            this.setlocalstorage("token", res.data.token);
            localStorage.setItem("phone", this.tel);
            localStorage.setItem("code", this.code);
            this.$router.push("/dsr");
            this.$store.commit("app/CHANGE_STATUS", false);
          }
        });
      }
    },
    setlocalstorage(key, data) {
      // 获取当前的时间
      let FirstTime = new Date().getTime();
      // 将当前时间存储本地
      return localStorage.setItem(
        key,
        JSON.stringify({
          data,
          time: FirstTime,
        })
      );
    },
  },
  computed: {
    status: {
      get() {
        return this.$store.state.app.status;
      },
      set() {},
    },
  },
};
</script>

<style lang="scss">
.Verification {
  padding: 0 1.02rem;
  height: 2.56rem;
  background: #0072f5;
  backdrop-filter: blur(0.48rem);
  .Verification-logo-width {
    height: 100%;
    display: flex;
    align-items: center;
  }
  .Verification-main {
    width: 100%;
    position: relative;
  }
  .Verification-main-title {
    margin-top: 2.6rem;
    margin-bottom: 0.613rem;
    text-align: center;
    font-size: 0.813rem;
    font-family: PingFangSC-Medium, PingFang SC;
  }
  .Verification-main-tips {
    padding: 0 1rem;
    font-size: 0.72rem;
    padding-top: 0.613rem;
    font-family: PingFangSC-Regular, PingFang SC;
    color: rgba(0, 0, 0, 0.64);
    line-height: 1.12rem;
    border-top: 0.053rem solid rgba(0, 0, 0, 0.06);
  }
  .tel,
  .verification-code {
    position: relative;
    width: 14.8rem;
    height: 2.25rem;
    margin: auto;
    background: #ffffff;
    border-radius: 0.16rem;
    border: 0.053rem solid rgba(0, 0, 0, 0.15);
    input {
      border: 0;
      padding: 0.68rem 0 0 0.61rem;
      font-size: 0.72rem;
    }
    .el-button {
      position: absolute;
      right: 0.2rem;
      top: 0.1rem;
      height: 2rem;
      background: transparent !important;
      border: 0 !important;
      span {
        font-size: 0.72rem;
        color: #262626;
      }
    }
    .line {
      position: absolute;
      left: 9rem;
      top: 0.51rem;
      width: 0.053rem;
      height: 1.12rem;
      border: 0.053rem solid #d9d9d9;
    }
  }
  .tel {
    margin-top: 0.92rem;
    margin-bottom: 0.3rem;
  }
  .el-button--primary {
    position: absolute;
    top: 12.5rem;
    right: 1.2rem;
    width: 14.8rem;
    height: 2.5rem;
    margin: auto;
    background: #0072f5;
    border-radius: 0.16rem !important;
    span {
      font-size: 0.72rem;
      font-weight: 500;
      font-family: PingFangSC-Medium, PingFang SC;
    }
  }
  .getCode {
    font-family: PingFangSC-Regular, PingFang SC;
  }
  .warn {
    font-size: 0.72rem;
    padding-left: 1.3rem;
    margin-top: 0.3rem;
    font-family: PingFangSC-Regular, PingFang SC;
  }
  .error {
    border-color: red;
  }
}
</style>
